'use client';

import { HeaderDivider } from '@components/FilterPage/VacancyList/VacancyDivider';
import { GridLayoutItem } from '@components/Layouts';
import { FactSlogan, freddyTheme, Typography } from '@coolblue-development/freddy';
import { Image } from '@coolblue-development/next-image/client';
import { useTranslation } from '@i18n/useTranslation';

export const HeroBanner = () => {
  const { t } = useTranslation('filterPage');
  const xSpacing = freddyTheme.spacing[400];
  const ySpacing = freddyTheme.spacing[600];
  const offsetOfBottom = '3.7rem';

  return (
    <>
      {/* Desktop */}
      <GridLayoutItem
        hideUntil='md'
        column='1/-1'
        row='1'
        paddingBottom={false}
        paddingTop={false}
        sx={{ height: `calc(40rem + ${offsetOfBottom})` }}
      >
        <Image
          imageId='599288'
          fileCollection='content'
          fullWidth
          width={4000}
          height={400}
          objectFit='cover'
          alt={''}
          loading={'eager'}
        />
      </GridLayoutItem>
      <GridLayoutItem
        hideUntil='md'
        column='2'
        row='1'
        justifySelf='center'
        alignSelf='end'
        backgroundColor='white'
        paddingTop={false}
        paddingBottom={false}
        sx={{
          width: `calc(100% + ${xSpacing} * 2)`,
          padding: `${ySpacing} ${xSpacing}`,
          borderTopRightRadius: freddyTheme.borderRadius[100],
          borderTopLeftRadius: freddyTheme.borderRadius[100]
        }}
      >
        <FactSlogan fact={t('heroBanner.fact')} slogan={t('heroBanner.slogan')} size='xlarge' />
      </GridLayoutItem>

      {/* Mobile */}
      <GridLayoutItem hideFrom='md' column='1/-1' row='1' paddingBottom={false} paddingTop={false}>
        <HeaderDivider />
        <Image
          imageId='599288'
          fileCollection='content'
          fullWidth
          width={800}
          height={160}
          objectFit='cover'
          alt={''}
          loading={'eager'}
        />
      </GridLayoutItem>
      <GridLayoutItem hideFrom='md' column='2' row='2' paddingBottom={false}>
        <Typography variant='h1' m='0'>
          {t('heroBanner.fact')}
        </Typography>
      </GridLayoutItem>
    </>
  );
};
